<!--This is for testing purpose where image is loading a little late after clearing cache-->
@if (isIconShown && iconSource) {
  <div [style.background-color]="color"
  [style.min-width.px]="messageLength" class="toastr-class">
    <span class="icon-success"><img [src]=iconSource alt=""/></span>
    <span id="toast" class="message">{{(message | translate) ? (message | translate): message}} </span>
  </div>
}
